import PropTypes from "prop-types";
import React, { Component } from "react";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CloseIcon from '@material-ui/icons/Close';
import TweenMax from "gsap/TweenMaxBase";
import Transition from "react-transition-group/Transition";
import {
    Container, ScrollableContainer, Text,
} from "../../../../../../components/index";
import { CategoryList } from "./CategoryList";
import { AccessoryList } from "./AccessoryList";
import { AccessoryDetails } from "./AccessoryDetails";
import { CosmeticList } from "./CosmeticList";
import { di } from "../../../../../../bottle";
import { BikeCatalog } from "../../../../../../managers/Garage/index";
import { SectionDetails } from "./SectionDetails";

// constants
const PANEL_BG = "#000000d0";


// class definition
export class Inventory extends Component {

    static propTypes = {
        show: PropTypes.bool.isRequired,
        catalog: PropTypes.instanceOf(BikeCatalog),
        onBikeChanged: PropTypes.func,
        onClose: PropTypes.func
    };

    static defaultProps = {
        show: false,
        onBikeChanged: () => undefined,
        onClose: () => undefined
    };

    static getDerivedStateFromProps(props, state) {
        // if the catalog changes reset state
        if (props.catalog && state.category && props.catalog.type !== state.category.type) {
            di.modelManager.resetCamera();
            return {
                category: null,
                section: null,
                part: null
            }
        }
        return null;
    }

    constructor(props) {

        // call base constructor
        super(props);

        // initialize instance variables
        this.animator = null;

        // set state
        this.state = {
            visible: false,
            bike: di.garage.bike,
            category: null,
            section: null,
            part: null
        };

        // bind methods
        this._onCategorySelected = this._onCategorySelected.bind(this);
        this._onSectionDetails = this._onSectionDetails.bind(this);
        this._onPartToggled = this._onPartToggled.bind(this);
        this._onPartInfo = this._onPartInfo.bind(this);
        this._onBack = this._onBack.bind(this);
        this._onClose = this._onClose.bind(this);
    }

    get title() {

        // resolve inputs
        const { category } = this.state;
        const { catalog } = this.props;
        const { localization } = di;

        // use part if shown
        if (category) {
            return category.name;
        } else if (catalog) {
            switch (catalog.type) {
                case BikeCatalog.Accessories:
                    return localization.get("build.buttons.build");
                case BikeCatalog.Cosmetics:
                    return localization.get("build.buttons.color");

            }
        }
    }

    componentDidMount() {

        // register for bike changes
        this._bikeChangesSubscription = di.garage.bikeChanges$
            .subscribe(bikeChanges => this.setState({ bike: bikeChanges.bike }));
    }

    componentWillUnmount() {

        // unregister bike changes
        if (this._bikeChangesSubscription) {
            this._bikeChangesSubscription.unsubscribe();
            this._bikeChangesSubscription = null;
        }
    }

    render() {

        // resolve inputs
        const { category, part } = this.state;
        const { show, onClose } = this.props;

        // create header
        const title = this.title;
        const backButton = category || part
            ? <Container style={styles.backButtonWrap}>
                <button onClick={this._onBack}>
                    <Container flex justify="center" style={styles.backButton}
                               alignItems="center">
                        <ChevronLeftIcon style={styles.backIcon} />
                    </Container>
                </button>
            </Container>
            : null;

        // create list
        const list = this._renderList();

        // render view
        return (
            <Transition
                timeout={1}
                mountOnEnter
                unmountOnExit
                in={show}
                addEndListener={(node, done) => {
                    const onComplete = () => {
                        this.setState({
                            visible: true
                        })
                    };
                    const onReverseComplete = () => {
                        this.setState({
                            visible: false
                        });
                        onClose();
                    };
                    this.animator = TweenMax.from(node, 0.7, {
                        autoAlpha: 0,
                        y:"+=50",
                        onComplete: onComplete,
                        onReverseComplete: onReverseComplete
                    })
                }}
            >
                <Container style={styles.container}>
                    <Container flex alignItems="center" justify="center" style={{position: "relative"}}>
                        <Container style={{width: "70%"}}>
                            <Container flex direction="row" alignItems="center" justify="space-between" alignContent="space-between">
                                <Container style={styles.titleWrap}>
                                    <Text style={styles.title} bold uppercase>{title}</Text>
                                </Container>
                                <Container style={{display: "flex"}} direction="row">
                                    <Container style={styles.backButtonWrap}>
                                        <button onClick={this._onClose}>
                                            <Container flex justify="center" style={styles.backButton}
                                                alignItems="center">
                                                <CloseIcon style={styles.backIcon} />
                                            </Container>
                                        </button>
                                    </Container>
                                    {backButton}
                                </Container>
                            </Container>
                            {list}
                        </Container>
                    </Container>
                </Container>
            </Transition>
        );
    }

    _renderList() {

        // resolve inputs
        const { show, catalog } = this.props;
        const { bike, category, section, part } = this.state;

        if (!show) {
            return null;
        }





        // show part details if selected
        let list;
        if (part) {
            list = <AccessoryDetails part={part} selected={bike.has(part)} />;
        }

        // or show section info if selected
        else if (section) {
            list = <SectionDetails section={section} />
        }

        // or show parts list
        else if (category) {
            list = catalog.type === BikeCatalog.Accessories
                ? (
                    <AccessoryList parts={category.parts}
                        bike={bike}
                        onPartToggled={this._onPartToggled}
                        onPartInfo={this._onPartInfo} />
                )
                : (
                    <CosmeticList parts={category.parts}
                        bike={bike}
                        onSectionDetails={this._onSectionDetails}
                        onPartToggled={this._onPartToggled} />
                );
        }

        // or show category list
        else {
            if (catalog.type === BikeCatalog.Accessories) {
                list = <CategoryList key="accessories"
                                     categories={catalog.categories}
                                     onCategorySelected={this._onCategorySelected} />;
            } else {
                list = <CategoryList key="cosmetics"
                                     categories={catalog.categories}
                                     onCategorySelected={this._onCategorySelected} />;
            }

        }

        // return list
        return list;
    }

    _onCategorySelected(category) {
        this.setState({ category });

        console.log("[Inventory] category selected", category);

        if (category.cameraPosition) {
            di.modelManager.setCameraPosition(category.cameraPosition)
        }
    }

    _onSectionDetails(section) {
        this.setState({ section });
    }

    _onPartToggled(part, category) {

        console.log("CORY ", category)
        // resolve inputs
        const { bike } = this.state;
        const dataLayer = window.dataLayer || [];

        // use remove part from bike (confirmation is handled by callback)
        if (bike.has(part)) {
            if(category === "accessories"){
                dataLayer.push({
                    'event':'e_build',
                    'action':'remove',
                    'buildcategory' :this.title,
                    'build': part.name
                });
            }
            di.garage.removeBikeParts([part], this.props.onBikeChanged);
        }

        // or to add a new part to bike
        else {
            //Analytics
            if(category === "cosmetics"){
                dataLayer.push({
                    'event':'e_color',
                    "colorcategory" : this.title,
                    'color': part.color
                });
            }
            else{
                dataLayer.push({
                    'event':'e_build',
                    'action':'add',
                    'buildcategory' :this.title,
                    'build': part.name
                });
            }
            di.garage.addBikeParts([part], this.props.onBikeChanged);
        }
    }

    _onPartInfo(part) {
        this.setState({ part });
    }

    _onBack() {
        console.log("back");
        const { visible, category, part, section } = this.state;

        // back to sections if within a section
        if (section) {
            this.setState({ section: null })
        }

        // or go back to parts if on a part
        else if (part) {
            this.setState({ part: null });
        }

        // or back to categories if within a category
        else if (category) {
            di.modelManager.resetCamera();
            this.setState({ category: null });
        }
    }

    _onClose() {
        if (this.state.visible) {
            di.modelManager.resetCamera();
            this.setState({
                category: null,
                section: null,
                part: null
            });
            this.animator.reverse();
        }
    }
}


const styles = {
    container: {
        position: "absolute",
        bottom: 0,
        right: 0,
        width: "100%"
    },
    titleWrap: {
        minWidth: 220,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 5,
        paddingBottom: 5,
        display: 'inline-flex',
        backgroundColor: PANEL_BG
    },
    title: {
        fontSize: 22,
        color: "#fff",
    },
    backButtonWrap: {
        justifySelf: "flex-end",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    },
    backButton: {
        width: 34,
        height: 34,
        marginLeft: 14,
        backgroundColor: PANEL_BG,
        borderRadius: 17
    },
    backIcon: {
        color: "#fff",
        fontSize: 32,
        lineHeight: 30
    },
    closeIcon: {
        fontSize: 30
    },
    list: {
        flex: 1,
        flexDirection: "row",
        paddingLeft: 6,
        paddingTop: 6,
    },
    item: {
        marginRight: 6,
        backgroundColor: "#3c3c3c"
    },
    placeholder: {
        minWidth: 135,
        height: 180,
    }
};



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/index.js